import { breakpoints } from '../themes/default/breakpoints'

export const setMediaQuery = (mq: MediaQueries, css: string) => {
  if (!css) {
    return ''
  }

  const mqDeclaration =
    mq === 'print'
      ? '@media print'
      : `@media only screen and (min-width: ${breakpoints[mq]})`

  return `
    ${mqDeclaration} {
      ${css}
    }
  `
}

export const setMediaQueryObj = (
  mq: MediaQueries,
  cssObject: Partial<CSSStyleDeclaration>
) => {
  if (!Object.keys(cssObject).length) {
    return {}
  }

  const mqDeclaration =
    mq === 'print'
      ? '@media print'
      : `@media only screen and (min-width: ${breakpoints[mq]})`

  return { [mqDeclaration]: cssObject } as unknown as TemplateStringsArray
}

///////// IMPLEMENTATION /////////

type MediaQueries = 'medium' | 'large' | 'xLarge' | 'print'
